/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>考核明细导入</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
		<div class="block1">
			 <el-radio-group v-model="tabtype" style="margin-bottom: 30px;" @change="choosetype">
				 <!-- <el-radio-button label="1" >业务代表提货数</el-radio-button> -->
				 <el-radio-button label="2">经销商/区域经理销量</el-radio-button>
				 <el-radio-button label="3">区域经理新商开发</el-radio-button>
				 
			 </el-radio-group>
		</div>
		<div class="block" v-if="tabtype=='2'">
			 <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @change="choosetab">
			     <el-radio-button label="经销商销量">经销商销量</el-radio-button>
			     <el-radio-button label="区域经理销量">区域经理销量</el-radio-button>
			 </el-radio-group>
		</div>
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
          <el-form-item label="名称"  v-if="tabtype=='1'">
            <el-input size="small" v-model="formProInfo.name" placeholder="输入名称"></el-input>
          </el-form-item>
		  
		  <el-form-item label="手机号" v-if="tabtype=='1'">
		    <el-input size="small" v-model="formProInfo.phoneNumber" placeholder="输入手机号"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="年份" v-if="tabtype=='1'">
		   <el-date-picker
		         v-model="formProInfo.year"
		         type="year"
		         placeholder="选择年"
				 :picker-options="pickerOptions"
				 value-format='yyyy'>
		       </el-date-picker>
		  </el-form-item>
		  
		  <el-form-item label="月份" v-if="tabtype=='1'">
			  <el-select size="small" v-model="formProInfo.month" placeholder="请选择月份">
			     <el-option label="1月" value="01"></el-option>
			     <el-option label="2月" value="02"></el-option>
			     <el-option label="3月" value="03"></el-option>
				 <el-option label="4月" value="04"></el-option>
				 <el-option label="5月" value="05"></el-option>
				 <el-option label="6月" value="06"></el-option>
				 <el-option label="7月" value="07"></el-option>
				 <el-option label="8月" value="08"></el-option>
				 <el-option label="9月" value="09"></el-option>
				 <el-option label="10月" value="10"></el-option>
				 <el-option label="11月" value="11"></el-option>
				 <el-option label="12月" value="12"></el-option>
			   </el-select>
			   <!-- <el-date-picker
				 v-model="formProInfo.month"
				 type="month"
				 placeholder="选择月" 
				 @change="changemonth"
				 value-format="MM">
			   </el-date-picker> -->
		  </el-form-item>
		  
		  <el-form-item label="客户编码"  v-if="tabtype=='2' && tabPosition=='经销商销量'">
		    <el-input size="small" v-model="dealerInfo.customerCode" placeholder="输入客户编码"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="客户名称"  v-if="tabtype=='2' && tabPosition=='经销商销量'">
		    <el-input size="small" v-model="dealerInfo.customerCompanyName" placeholder="输入客户名称"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="客户姓名"  v-if="tabtype=='2' && tabPosition=='经销商销量'">
		    <el-input size="small" v-model="dealerInfo.customerName" placeholder="输入客户姓名"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="业务月份"  v-if="tabtype=='2' && tabPosition=='经销商销量'">
		    <el-date-picker
				 v-model="dealerInfo.businessMonth"
				 type="month"
				 placeholder="选择业务月份" 
				 value-format="yyyy-MM">
		    </el-date-picker>
		  </el-form-item>
		  
		  <el-form-item label="区域经理"  v-if="tabtype=='2' && tabPosition=='区域经理销量'">
		    <el-input size="small" v-model="salesInfo.name" placeholder="输入区域经理"></el-input>
		  </el-form-item>
		  <el-form-item label="大区"  v-if="tabtype=='2' && tabPosition=='区域经理销量'">
		    <el-input size="small" v-model="salesInfo.area" placeholder="输入大区"></el-input>
		  </el-form-item>
		  <el-form-item label="渠道类别"  v-if="tabtype=='2' && tabPosition=='区域经理销量'">
		    <el-input size="small" v-model="salesInfo.channelType" placeholder="输入渠道类别"></el-input>
		  </el-form-item>
		  <el-form-item label="业务月份"  v-if="tabtype=='2' && tabPosition=='区域经理销量'">
		    <el-date-picker
			 v-model="salesInfo.businessMonth"
			 type="month"
			 placeholder="选择业务月份" 
			 value-format="yyyy-MM">
		    </el-date-picker>
		  </el-form-item>
		  
		  <el-form-item label="区域经理"  v-if="tabtype=='3'">
		    <el-input size="small" v-model="developInfo.name" placeholder="输入区域经理"></el-input>
		  </el-form-item>
		  <el-form-item label="核算月份"  v-if="tabtype=='3'">
		    <el-select size="small" v-model="formProInfo.accountingMonth" placeholder="请选择月份">
				<el-option label="1月" value="01"></el-option>
				<el-option label="2月" value="02"></el-option>
				<el-option label="3月" value="03"></el-option>
				 <el-option label="4月" value="04"></el-option>
				 <el-option label="5月" value="05"></el-option>
				 <el-option label="6月" value="06"></el-option>
				 <el-option label="7月" value="07"></el-option>
				 <el-option label="8月" value="08"></el-option>
				 <el-option label="9月" value="09"></el-option>
				 <el-option label="10月" value="10"></el-option>
				 <el-option label="11月" value="11"></el-option>
				 <el-option label="12月" value="12"></el-option>
		     </el-select>
		  </el-form-item>
		  
		 
        
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
		 <div class="block2">
			 <el-button type="primary" size="small" @click="importDialogVisible">导入文件</el-button> 
			 <el-button size="small" @click="dialogVisible">下载文件</el-button> 
		 </div>
		 
		 <el-dialog
		   title="请选择文件"
		   :visible.sync="centerDialogVisible"
		   width="30%"
		   center>
		   <div class="block2">
		     <el-upload
		     :on-preview="handlePreview"
		     multiple
		     :on-exceed="handleExceed"
		     :action="uploadUrl()"
			 ref="upload"
			 list-type="text"
			 :multiple="false"
		     :http-request="customUpload">
		     <el-button size="small" >点击选择导入文件</el-button>
		     </el-upload>
		   </div>
		   <span slot="footer" class="dialog-footer">
		     <el-button @click="centerDialogVisible = false">取 消</el-button>
		     <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		   </span>
		 </el-dialog>
		 
		 
		
        <!--列表-->
		<el-table v-if="tabtype=='1'" size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column align="center" prop="name" label="名称">
			</el-table-column>
			<el-table-column align="center" prop="phoneNumber" label="手机号">
			</el-table-column>
			<el-table-column align="center" prop="year" label="年">
			</el-table-column>
			<el-table-column align="center" prop="month" label="月">
			</el-table-column>
			<el-table-column align="center" prop="goodsNum" label="提货数量">
			</el-table-column>
			<el-table-column align="center" prop="updateTime" label="更新时间">
			</el-table-column>
		</el-table>
		
		<el-table v-if="tabtype=='2' && tabPosition=='经销商销量'" size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column align="center" prop="customerCode" label="客户编码">
			</el-table-column>
			<el-table-column align="center" prop="customerCompanyName" label="客户名称">
			</el-table-column>
			<el-table-column align="center" prop="grossAmount" label="经销商含税金额">
			</el-table-column>
			<el-table-column align="center" prop="businessMonth" label="业务月份">
			</el-table-column>
			<el-table-column align="center" prop="updateTime" label="更新时间">
			</el-table-column>
		</el-table>
		
		<el-table v-if="tabtype=='2' && tabPosition=='区域经理销量'" size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column align="center" prop="loginAccount" label="OA账号">
			</el-table-column>
			<el-table-column align="center" prop="name" label="区域经理">
			</el-table-column>
			<el-table-column align="center" prop="channelType" label="渠道类别">
			</el-table-column>
			<el-table-column align="center" prop="area" label="大区">
			</el-table-column>
			<el-table-column align="center" prop="grossAmount" label="经销商含税金额">
			</el-table-column>
			<el-table-column align="center" prop="businessMonth" label="业务月份">
			</el-table-column>
			<el-table-column align="center" prop="updateTime" label="更新时间">
			</el-table-column>
		</el-table>
		
		<el-table v-if="tabtype=='3'" size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column align="center" type="selection" width="50">
			</el-table-column>
			<el-table-column align="center" prop="loginAccount" label="OA账号">
			</el-table-column>
			<el-table-column align="center" prop="name" label="区域经理">
			</el-table-column>
			<el-table-column align="center" prop="actualNumber" label="实际个数">
			</el-table-column>
			<el-table-column align="center" prop="accountingMonth" label="核算月份">
			</el-table-column>
			<el-table-column align="center" prop="updateTime" label="更新时间">
			</el-table-column>
		</el-table>
		
        
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      queryPagePickUpGoodsList,
	  queryPageSalesList,
	  queryPageDevelopDealerList,
	  importExcel,
	  exportExcel,
	  queryPageSalesListOfDealer,
	  voucherDownload
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  pickerOptions: {
			  disabledDate(time) {
				  let currentYear = new Date().getFullYear();
				  // 设置可选择的最小年份为2020年
				  let earliestYear = 2020;
				  // 设置可选择的最大年份为当前年份后三年
				  let latestYear = currentYear + 3;
				  return (
					time.getFullYear() < earliestYear ||
					time.getFullYear() > latestYear
				  );
			  }
		 },	
         loading: false, //是显示加载
         tabPosition:'经销商销量',
		 centerDialogVisible:false,
		 tabtype:'2',
		 filelist:'',
		 resultFilelist:'',
		 value2:'',
		 value3:'',
		 value1:'',
          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
		   phoneNumber:'',
		   year:'',
		   month:''
			
          },
		  dealerInfo:{
			pageIndex: 1,
			pageSize: 10,
			customerCode:'',
			customerCompanyName:'',
			customerName:'',
			businessMonth:''
		  },
		  salesInfo:{
			 pageIndex: 1,
			 pageSize: 10,
			 businessMonth:'',
			  name:'',
			  area:'',
			  channelType:''
		  },
		  developInfo:{
			pageIndex: 1,
			pageSize: 10,
			accountingMonth:'',
			name:'',
		  },
		  
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getDealerData(this.dealerInfo)
		//this.getGoodsData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		 importDialogVisible(){
			 this.centerDialogVisible = true
		 },
		 changemonth(e){
			 console.log(12368,e)
			 this.formProInfo.month = e
		 },
		  //添加
		  add: function() {
		  	this.loading = true
		  	importExcel(pageparm).then(res => {
		  	  console.log(123)
		  	  this.loading = false
		  	  if (res.success == false) {
		  	    this.$message({
		  	      type: 'info',
		  	      message: res.msg
		  	    })
		  	  } else {
		  	    this.$message({
		  	      type: 'success',
		  	      message: res.msg
		  	    })
		  	  }
		  	})
		   
		  },
		  //导出
		  dialogVisible(){
			 console.log(1)
			 let _this = this
			 if(this.tabtype=='1'){
				var excelInfo={
					type:'1',
					pickUpGoodsQueryDto:{
					  name:'',
					  phoneNumber:'',
					  year:'',
					  month:'',
					  pageIndex:1,
					  pageSize:10 
					}	
				}
			 	
			 }
			 if(this.tabtype=='2'&&this.tabPosition=='经销商销量'){
					var excelInfo={
						type:'2',
						salesOfDealerQueryDto:{
						  customerCode:'',
						  customerCompanyName:'',
						  customerName:'',
						  businessMonth:'',
						  pageIndex:1,
						  pageSize:10 
						},
					}
			 	
			 }
			 if(this.tabtype=='2'&&this.tabPosition=='区域经理销量'){
				var excelInfo={
					type:'2',
					salesQueryDto:{
					  name:'',
					  area:'',
					  channelType:'',
					  businessMonth:'',
					  pageIndex:1,
					  pageSize:10 
					},
				}
			 	
			 }
			 if(this.tabtype=='3'){
				var excelInfo={
					type:'3',
					developDealerQueryDto:{
					  name:'',
					  accountingMonth:'',
					  pageIndex:1,
					  pageSize:10 
					}
				}
			 	
			 }
			 
			voucherDownload(excelInfo)
			   .then(res => {
					console.log(res);
					const blob = new Blob([res.data]);
					let fileNameUrl = res.headers['content-disposition'].split(";")[1]
					let filestr = fileNameUrl.split("filename=")[1]
					const fileName = decodeURI(filestr)
					console.log(898980,fileNameUrl)
					// return
					//对于<a>标签，只有 Firefox 和 chrome (内核) 支 download//IE10以上支梯blob，但是依然不支持donload
					if ('download' in document.createElement( "a")) {//支持a标签download的浏览器
						const link = document.createElement('a');//创建a标签
						link.download = fileName;//a标签添加属性
						link.style.display = "none"
						link.href = URL.createObjectURL(blob);
						document.body.appendChild(link);
						link.click();//执行下载
						URL.revokeObjectURL(link.href); //释放url
						document.body.removeChild(link);//释放标签else
						 this.$message({
						   type: 'success',
						   message: '下载成功！'
						 })
					}else{
						navigator.msSaveBlob(blob,fileName);
					}
					
				})
		  },
		  uploadUrl(){
		    return '/web-v2/kpiDetailImport/importExcel.json'
		  },
		 
		  //限制上传个数不超过9个
		  handleExceed(files,fileList){
		    if(fileList && fileList.length == 1){
		      this.$message.warning('上传文件不可超过1个')
		    }
		  },
		  handlePreview(file){
		    console.log(file)
		   
		  },
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
			formData.append('type', this.tabtype);
			
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  			console.log(9090901,response.data.data)	 
		        if(response.data.data.flag==true){
		         this.$message({
				   message: '上传成功',
				   type: 'success'
				 });
				 this.clearFiles();
				 this.centerDialogVisible = false
		          if(this.tabtype=='1'){
					  this.getGoodsData(this.formProInfo) 
				  }
				  if(this.tabtype=='2'&&this.tabPosition=='经销商销量'){
					  this.getDealerData(this.dealerInfo)
				  }
				  if(this.tabtype=='2'&&this.tabPosition=='区域经理销量'){
				  		this.getSalesData(this.salesInfo)
				  }
				  if(this.tabtype=='3'){
					  this.getDevelopDealerData(this.developInfo)
				  }
		        }else{
					this.clearFiles();
		          this.$message.error(response.data.data.errorMsg)
				  
		        }
		      
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		       this.clearFiles();
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		   clearFiles() {
			 this.$refs.upload.clearFiles(); // 清除文件列表
		   },
		  choosetab(e){
			  console.log(33333,e)
			  if(this.tabPosition=='经销商销量'){
				 this.getDealerData(this.dealerInfo) 
			  }else{
				this.getSalesData(this.salesInfo) 
			  }
		  },
		 choosetype(e){
			if(this.tabtype=='1'){
				this.getGoodsData(this.formProInfo)
			}else if(this.tabtype=='2'){
				if(this.tabPosition=='经销商销量'){
					this.getDealerData(this.dealerInfo)
				}else{
					this.getSalesData(this.salesInfo)
				}
				
			}else if(this.tabtype=='3'){
				
				this.getDevelopDealerData(this.developInfo)
			}
		 },
		  
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.phoneNumber=''
			this.formProInfo.year=''
			this.formProInfo.month=''
			this.dealerInfo.customerCode=''
			this.dealerInfo.customerCompanyName=''
			this.dealerInfo.customerName=''
			this.dealerInfo.businessMonth=''
			this.salesInfo.businessMonth=''
			this.salesInfo.name=''
			this.salesInfo.area=''
			this.salesInfo.channelType=''
			this.developInfo.accountingMonth=''
			this.developInfo.name=''
			
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取业务代表or经销商 提货数考核明细
        getGoodsData(pageparm) {
          this.loading = true
          queryPagePickUpGoodsList(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  
              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
		// 查询区域经理销量
		getSalesData(pageparm) {
		  this.loading = true
		  queryPageSalesList(pageparm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 查询经销商销量
		getDealerData(pageparm) {
		  this.loading = true
		  queryPageSalesListOfDealer(pageparm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
		// 查询区域经理or大区经理 新商开发考核明细
		getDevelopDealerData(pageparm) {
		  this.loading = true
		  queryPageDevelopDealerList(pageparm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		      this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
				  item.area = item.province+item.city+item.county
			  })
			  
		      // 分页赋值
		      this.pageparm.currentPage = this.formProInfo.pageIndex
		      this.pageparm.pageSize = this.formProInfo.pageSize
		      this.pageparm.total = res.total
		    }
		  })
		},
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          
		  if(this.tabtype=='2' &&  this.tabPosition=='经销商销量'){
			  this.dealerInfo.pageIndex = 1
			 this.getDealerData(this.dealerInfo) 
		  }
		  if(this.tabtype=='2' &&  this.tabPosition=='区域经理销量'){
			  this.salesInfo.pageIndex = 1
		  	  this.getSalesData(this.salesInfo) 
		  }
		  if(this.tabtype=='1'){
			  this.formProInfo.pageIndex = 1
		  	this.getGoodsData(this.formProInfo) 
		  }
		  if(this.tabtype=='3'){
			  this.developInfo.pageIndex = 1
		  	this.getDevelopDealerData(this.developInfo)
		  }
          
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
      
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 80px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 63px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 0px;  
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  }
  .user-search{
	  position: relative;
  }
  /deep/ .el-radio-button__inner{
	  width: 200px;
  }
  /deep/ .el-radio-button__inner{
	  padding: 8px 20px;
  }
  .block{
	  display: flex;
  }
  /deep/ .block .el-input__inner{
	  line-height: 32px;
	  height: 32px;
	  border: 0;
  }
  .block1{
  	  display: flex;
	  margin-top: 40px;
  }
  .block2{
  	  display: flex;
	  margin-bottom: 20px;
  }
  /deep/ .block1 .el-input__inner{
  	  line-height: 32px;
  	  height: 32px;
  	  border: 0;
  }
  /deep/ .el-input__icon{
	  font-size: 20px;
	  height: 36px;
	  line-height: 32px;
  }
  .upload-files{
	  margin-right: 10px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/assessment/assessmentDetails.vue